























































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import { required, minLength, between } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';
import { SensorsApi, Sensor } from '../../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		secondaryNav,
		vSelect,
		Toast,
	},
	validations: {
		form: {
			// transceiverID: {required},
			uniqueId: { required },
			serialNumber: { required },
			type: {},
		},
	},
	mixins: [validationMixin],
})
export default class SensorCreate extends Vue {
	public form = {
		// transceiverID: '',
		uniqueId: '',
		serialNumber: '',
		type: '',
	};
	public errors = [];
	public transceivers: any = [];
	public $bvToast: any;
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public type = null;
	public options = [
		{ value: null, text: 'Unassigned' },
		{ value: 'temp', text: 'Vat Temperature' },
		{ value: 'capacitance', text: 'Capacitance' },
		{ value: 'inlet', text: 'Inlet Temp' },
		{ value: 'lidarDistance', text: 'Lidar Distance' },
		{ value: 'radarDistance', text: 'Radar Distance' },
		{ value: 'lidarTemp', text: 'Lidar Temp' },
		{ value: 'stirrer', text: 'Stirrer' },
	];

	constructor() {
		super();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const sensor: Sensor = this.form;

		let response;

		try {
			response = await new SensorsApi().addSensor({ data: sensor });
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Creating Sensor', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('New Sensor', 'Successfully Created', 'success');
		this.submitStatus = 'OK';

		setTimeout(() => {
			this.$router.push({ name: 'sensors.view', params: { sensorId: response.data.data.id } });
		}, 1000);
	}
}
